import { PasFolders, PasRcs } from '../enums';

export class PasDataServiceApiUtil {

	public static createPcRcsPath(rcs: PasRcs): string {
		return PasDataServiceApiUtil.createRcsPath(PasFolders.PC, rcs);
	}

	public static createAcRcsPath(rcs: PasRcs): string {
		return PasDataServiceApiUtil.createRcsPath(PasFolders.AC, rcs);
	}

	public static createAuRcsPath(rcs: PasRcs): string {
		return PasDataServiceApiUtil.createRcsPath(PasFolders.AU, rcs);
	}

	private static createRcsPath(directory: PasFolders, rcs: PasRcs): string {
		return directory + ':' + rcs;
	}

	public static createLmRcsPath(rcs: PasRcs): string {
		return PasDataServiceApiUtil.createRcsPath(PasFolders.LM, rcs);
	}
}
